import { useCallback, useState } from "react";

import type { FuenteDeLaPropuesta } from "@/lib/rellenoConIa";

/**
 * La fuente del TEXTO que "Rellenar con IA" escribió en la descripción general.
 *
 * Vale solo mientras el texto siga siendo el que la IA escribió: si la persona
 * lo cambia, la fuente ya no lo describe y se esconde. Tampoco sobrevive a
 * descartar, a guardar la pestaña ni a un relleno nuevo (que vuelve a
 * `registrar`). Nunca se guarda: es ayuda para revisar.
 *
 * `visible` es `null` cuando no hay nada que mostrar, y `{ fuente: null }` cuando
 * sí hay que mostrar "Fuente no indicada" — son casos distintos.
 */
export function useFuenteDeLaDescripcion(descripcion: string) {
  const [propuesto, setPropuesto] = useState<{
    texto: string;
    fuente: FuenteDeLaPropuesta | null;
  } | null>(null);

  const registrar = useCallback((texto: string, fuente: FuenteDeLaPropuesta | null) => {
    setPropuesto({ texto, fuente });
  }, []);

  const olvidar = useCallback(() => setPropuesto(null), []);

  const visible =
    propuesto !== null && descripcion === propuesto.texto ? { fuente: propuesto.fuente } : null;

  return { visible, registrar, olvidar };
}
